// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const zaaptvColors: ColorType = { ...colorPalette, primary: '#f38931', signColor: '#f38931' }

export const lightTheme = {
  colors: zaaptvColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: zaaptvColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: zaaptvColors.dark,
    secondary: zaaptvColors.grayText,
    disabled: zaaptvColors.dark,
    link: zaaptvColors.dark,
    hint: zaaptvColors.dark,
    highlight: zaaptvColors.primary,
    gray: zaaptvColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: zaaptvColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: zaaptvColors.dark,
    color: zaaptvColors.dark,
    border: zaaptvColors.primary,
    scrollbarThumb: zaaptvColors.primary,
    programTitle: zaaptvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: zaaptvColors.dark,
        selected: zaaptvColors.dark,
        progress: rgba(zaaptvColors.primary, 0.3),
        past: rgba(zaaptvColors.primary, 0.3),
        pastSelected: zaaptvColors.dark,
        pastHover: zaaptvColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(zaaptvColors.primary, 0.1),
      },
      text: {
        empty: zaaptvColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: zaaptvColors.dark,
    subTitle: zaaptvColors.grayText,
    bg: zaaptvColors.dark,
    number: zaaptvColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
